var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        {
          staticClass: "mt-20 p-5",
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.1)" },
        },
        [
          _c("vs-col", { staticClass: "p-0" }, [
            _c("span", { staticClass: "font-bold text-lg" }, [
              _vm._v("Autres objectifs :"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.resources.length > 0
        ? _c(
            "vs-row",
            { staticClass: "mt-10" },
            [
              _c(
                "vs-col",
                { staticClass: "w-full" },
                _vm._l(_vm.resources, function (res, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "py-5 mt-1 border-bottom" },
                    [
                      _c(
                        "vs-collapse",
                        [
                          _c(
                            "vs-collapse-item",
                            { attrs: { "not-arrow": false } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "vs-row",
                                    [
                                      _c(
                                        "vs-col",
                                        {
                                          staticClass: "mb-3",
                                          attrs: {
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "8",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "font-bold" },
                                            [_vm._v("Libellé")]
                                          ),
                                          _vm._v(" "),
                                          res.id && !res.is_edit
                                            ? _c(
                                                "ms-chip",
                                                {
                                                  attrs: {
                                                    color: _vm.getColorFor(
                                                      "occupationSkill",
                                                      1
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(_vm._s(res.label)),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "vs-button",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: {
                                                        color: "dark",
                                                        type: "flat",
                                                      },
                                                      on: {
                                                        click: (event) =>
                                                          _vm.handleClickEditLabel(
                                                            event,
                                                            res,
                                                            i
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-pencil ml-1",
                                                        attrs: {
                                                          title:
                                                            "Modifier le libellé",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c("vs-input", {
                                                staticClass: "w-full ml-5",
                                                attrs: {
                                                  value: res.label,
                                                  name: "label",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.debouncedInputHandleLabel(
                                                      res,
                                                      $event
                                                    )
                                                  },
                                                  click: (event) =>
                                                    event.stopPropagation(),
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "vs-col",
                                        {
                                          staticClass: "mb-3",
                                          attrs: {
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "3",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "font-bold" },
                                            [_vm._v("État")]
                                          ),
                                          _vm._v(" "),
                                          _c("Multiselect", {
                                            staticClass: "multiselect-sm",
                                            attrs: {
                                              options: _vm.states,
                                              "track-by": "id",
                                              label: "name",
                                              multiple: false,
                                              "group-select": false,
                                              placeholder: "Choisir...",
                                              "select-label": "",
                                              "select-group-label": "",
                                              "selected-label": "",
                                              "deselect-label": "",
                                              "deselect-group-label": "",
                                              disabled: _vm.readonly,
                                            },
                                            model: {
                                              value: res.state,
                                              callback: function ($$v) {
                                                _vm.$set(res, "state", $$v)
                                              },
                                              expression: "res.state",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "vs-col",
                                        {
                                          staticClass: "mb-3",
                                          attrs: {
                                            "vs-justify": "center",
                                            "vs-align": "center",
                                            "vs-w": "1",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "font-bold" },
                                            [_vm._v(" ")]
                                          ),
                                          _vm._v(" "),
                                          _c("vs-button", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              color: "primary",
                                              type: "border",
                                              "icon-pack": "feather",
                                              icon: "icon-trash",
                                              disabled: _vm.readonly,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteResource(i)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-row",
                                [
                                  _c(
                                    "vs-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "vs-justify": "center",
                                        "vs-align": "center",
                                        "vs-w": "4",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "font-bold" }, [
                                        _vm._v("Thème"),
                                      ]),
                                      _vm._v(" "),
                                      _c("SemiSelectForm", {
                                        attrs: {
                                          classes: "multiselect-sm",
                                          availables: _vm.themesList,
                                          "field-label": "thème",
                                        },
                                        model: {
                                          value: res.theme,
                                          callback: function ($$v) {
                                            _vm.$set(res, "theme", $$v)
                                          },
                                          expression: "res.theme",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vs-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "vs-justify": "center",
                                        "vs-align": "center",
                                        "vs-w": "2",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "font-bold" }, [
                                        _vm._v("Date d'échéance"),
                                      ]),
                                      _vm._v(" "),
                                      _c("vs-input", {
                                        staticClass: "w-full",
                                        attrs: { type: "date", name: "due_at" },
                                        model: {
                                          value: res.due_at,
                                          callback: function ($$v) {
                                            _vm.$set(res, "due_at", $$v)
                                          },
                                          expression: "res.due_at",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vs-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "vs-justify": "center",
                                        "vs-align": "center",
                                        "vs-w": "2",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "font-bold" }, [
                                        _vm._v("Date de notification"),
                                      ]),
                                      _vm._v(" "),
                                      _c("vs-input", {
                                        staticClass: "w-full",
                                        attrs: {
                                          type: "date",
                                          name: "notify_at",
                                        },
                                        model: {
                                          value: res.notify_at,
                                          callback: function ($$v) {
                                            _vm.$set(res, "notify_at", $$v)
                                          },
                                          expression: "res.notify_at",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vs-col",
                                    {
                                      staticClass: "mb-3",
                                      attrs: {
                                        "vs-justify": "center",
                                        "vs-align": "center",
                                        "vs-w": "4",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "font-bold" }, [
                                        _vm._v("Utilisateurs à notifier"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "Multiselect",
                                        {
                                          staticClass: "multiselect-sm",
                                          attrs: {
                                            options: _vm.users.data,
                                            multiple: true,
                                            placeholder: "Recherche ...",
                                            "track-by": "id",
                                            label: "full_name",
                                            "select-label": "",
                                            "selected-label": "",
                                            "deselect-label": "",
                                            loading: _vm.users.loading,
                                          },
                                          model: {
                                            value: res.notify_users_field,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                res,
                                                "notify_users_field",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "res.notify_users_field",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "afterList" },
                                              slot: "afterList",
                                            },
                                            [
                                              _c("div", {
                                                staticStyle: {
                                                  "min-height": "25vh",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-row",
                                [
                                  _c("vs-col", [
                                    _c("div", { staticClass: "font-bold" }, [
                                      _vm._v("Moyens à mettre en oeuvre"),
                                    ]),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      staticClass: "vs-textarea",
                                      staticStyle: {
                                        "background-color": "#fff",
                                      },
                                      domProps: { value: res.means },
                                      on: {
                                        input: function ($event) {
                                          return _vm.debouncedInputHandleMeans(
                                            res,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mt-5" },
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "3", "vs-align": "flex-end" } },
            [
              _vm.planAllow("saisie-objectifs")
                ? _c(
                    "vs-button",
                    {
                      attrs: {
                        color: "primary",
                        type: "border",
                        "icon-pack": "feather",
                        icon: "icon-plus",
                      },
                      on: { click: _vm.addResource },
                    },
                    [
                      _vm._v(
                        "\n                Ajouter un objectif\n            "
                      ),
                    ]
                  )
                : !_vm.shouldHideOptions()
                ? _c(
                    "div",
                    {
                      staticStyle: { position: "relative", float: "left" },
                      attrs: {
                        title:
                          "Votre formule n'inclut pas cette fonctionnalité",
                      },
                    },
                    [
                      _c(
                        "vs-button",
                        {
                          attrs: {
                            color: "primary",
                            type: "border",
                            "icon-pack": "feather",
                            icon: "icon-plus",
                            disabled: "true",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Ajouter un objectif\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-icon",
                        {
                          staticClass: "button-bullet",
                          attrs: { bg: "#FF9B3A", round: "" },
                        },
                        [
                          _c("CrownIcon", {
                            staticStyle: {
                              width: "16px",
                              height: "16px",
                              padding: "3px",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }